
namespace Matrix.Workflow {

    export interface ClientSummaryGridOptions {
        refreshInterval?: number;
    }

    @Serenity.Decorators.registerClass()
    export class ClientFunctionSummaryGrid extends SiteEntityGrid<ClientFunctionRow, ClientSummaryGridOptions> {
        protected getColumnsKey() { return 'Workflow.ClientFunction'; }
        protected getDialogType() { return ClientFunctionSummaryDialog; }
        protected getIdProperty() { return ClientFunctionRow.idProperty; }
        protected getLocalTextPrefix() { return ClientFunctionRow.localTextPrefix; }
        protected getService() { return ClientFunctionService.baseUrl; }

        private refreshTimer: number;

        constructor(container: JQuery, opt: ClientSummaryGridOptions) {
            super(container, opt);

            this.refresh();
            this.refreshTimer = window.setInterval(this.refresh.bind(this), (this.options.refreshInterval || 30) * 1000);
        }
 
        destroy() {
            if (this.refreshTimer) {
                window.clearInterval(this.refreshTimer);
                this.refreshTimer = null;
            }

            super.destroy();
        }

        getInitialTitle() {
            return "Functions";
        }

        getIncludeColumns(include) {
            super.getIncludeColumns(include);
            include[ClientFunctionRow.Fields.LastInvocationId] = true;
            include[ClientFunctionRow.Fields.Runnable] = true;
        }

        getButtons() {
            return super.getButtons().filter(x => x.cssClass != "add-button");
        }

        getColumns() {
            var columns = super.getColumns();

            var enabled = Q.tryFirst(columns, x => x.field == ClientFunctionRow.Fields.Enabled);
            if (enabled && Q.Authorization.hasPermission('DataAdmin:ClientFunction')) {
                enabled.format = ctx => {
                    return `<input class="inline-action toggle-enabled" style="opacity: 1; min-height: 0;" type="checkbox"${ctx.value ? " checked": ""}/>`;
                }
            }

            var groupName = Q.tryFirst(columns, x => x.field == ClientFunctionRow.Fields.GroupName);
            if (groupName) {
                groupName.grouping = {
                    getter: ClientFunctionRow.Fields.GroupName,
                    formatter: function (g: Slick.Group<any>) {
                        return Q.htmlEncode(g.value);
                    }
                }
            }

            var triggerDefinition = Q.tryFirst(columns, x => x.field == ClientFunctionRow.Fields.TriggerDefinition);
            if (triggerDefinition) {
                triggerDefinition.format = ctx => {
                    if (ctx.value) {
                        if (Q.Authorization.hasPermission('DataAdmin:ClientFunction') && (<ClientFunctionRow>ctx.item).TriggerType !== "Timer")
                            return `<a class="inline-action schedule-edit" title="Edit this schedule"><i class="fa fa-wrench"></i> ${Q.htmlEncode(ctx.value)}</a>`;
                        else
                            return Q.htmlEncode(ctx.value);
                    }
                };
            }

            return columns;
        }

        protected onClick(e, row, cell) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as ClientFunctionRow;
            var target = $(e.target);
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('toggle-enabled')) {
                    Q.confirm(`${item.Enabled ? 'Disable' : 'Enable'} this function?`, () => {
                        ClientFunctionService.Update({
                            EntityId: item.FunctionName,
                            Entity: {
                                Enabled: !item.Enabled
                            }
                        },
                            response => {
                                this.refresh();
                            })
                    });
                }

                if (target.hasClass('schedule-edit')) {
                    
                    var dlg = new ClientFunctionScheduleDialog({
                        Schedule: item.TriggerDefinition
                    });

                    dlg.onSuccess = (scheduleName) => {
                        dlg.dialogClose();

                        ClientFunctionService.Update({
                            EntityId: item.FunctionName,
                            Entity: {
                                TriggerDefinition: scheduleName
                            }
                        },
                            response => {
                                this.refresh();
                            })

                        return true;
                    };
                    dlg.dialogOpen();
                }
            }
        }

        protected gridPersistanceFlags() {
            var flags = super.gridPersistanceFlags();
            flags.groupColumns = false;
            return flags;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var mixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            mixin.plugin.setDroppedGroups([ClientFunctionRow.Fields.GroupName]);
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.groupingPanel = true;
            return opt;
        }

        private firstLoad: boolean = true;

        protected markupReady() {
            super.markupReady();

            if (this.firstLoad) {
                this.view.expandAllGroups(null);
                this.firstLoad = false;
            }
        }

        protected usePager() {
            return false;
        }
    }
}